import _ from 'underscore';
import Util from 'views/utils/LeafletMap/utils/Util';
import MapProvider from 'views/utils/LeafletMap/MapProviders/MapProvider';
import GarminDirectionService from 'views/utils/LeafletMap/MapServices/GarminDirectionService';
import HERELocationService from 'views/utils/LeafletMap/MapServices/HERELocationService';

var LayerTypeMapping = {
    ROAD: 'mapbox.streets',
    SATELLITE: 'mapbox.satellite'
};

var TileLayer = {
    url: 'https://connectcache20.azureedge.net/',
    options: {
        minZoom: 3,
        maxZoom: 17,
        attribution:
            '&copy; <a href="https://openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMaps</a> contributors &copy; Garmin Ltd. or its Affiliates'
    }
};

var GarminOpenStreetMapProvider = function(args) {
    MapProvider.apply(this, arguments);

    if (args.layerType && LayerTypeMapping[args.layerType]) {
        // do we support this layer?
        TileLayer.options.id = LayerTypeMapping[args.layerType];
    } else {
        TileLayer.options.id = LayerTypeMapping.ROAD; // default
    }

    this.directionService = new GarminDirectionService({
        transitMode: args.transitMode
    });

    this.locationService = new HERELocationService({});

    this.name = Util.MapProviders.OSM;
};

GarminOpenStreetMapProvider.prototype = Object.create(MapProvider.prototype);
GarminOpenStreetMapProvider.prototype.constructor = GarminOpenStreetMapProvider;

//SHARED METHODS
GarminOpenStreetMapProvider.prototype.getTileLayer = function getTileLayer(layerType) {
    if (layerType && LayerTypeMapping[layerType]) {
        // do we support this layer?
        TileLayer.options.id = LayerTypeMapping[layerType];
    }
    return TileLayer;
};

GarminOpenStreetMapProvider.prototype.getSupportedMaxZoom = function getSupportedMaxZoom() {
    return TileLayer.options.maxZoom;
};

GarminOpenStreetMapProvider.TileLayer = TileLayer;

export default GarminOpenStreetMapProvider;
